import { Button, Modal, Form, FormControl } from 'react-bootstrap';
import React, { useState, useEffect } from 'react';
import UserCourseService from '../../service/userCourseService';
import useToken from '../../App/useToken';
import { useParams } from 'react-router-dom';
import { List, arrayMove } from 'react-movable';
import Select from 'react-select';

import './StudentCourseSortModal.css'

export default function StudentChangeTermModal({ 
  getStudentCourse, 
  showStudentCourseSortModal, 
  setShowStudentCourseSortModal,
  errorNotify, 
  successNotify,
  setStudentCourses,
  studentCourses }) {
    const { course_name } = useParams();
    const { isUnitAdmin, isUnitSpcAdmin, isAdmin, getToken } = useToken();
    const isUserUnitAdmin = isUnitAdmin();
    const isUserUnitSpcAdmin = isUnitSpcAdmin();
    const isUserAdmin = isAdmin();
    const token = getToken();
    const [rankShotSort, setRankShotSort ] = useState();
    const [ageSort, setAgeSort ] = useState();
    const [seniorOfRankSort, setSeniorOfRankSort ] = useState();
    const [startDateSort, setStartDate ] = useState();
    const [bornEduNameSort, setBornEduNameSort ] = useState();
    const [degreeAbbrNameSort, setDegreeAbbrNameSort ] = useState();
    const [unitSort, setUnitSort ] = useState();
    const [spcSort, setSpcSort ] = useState();
    const [positionAddDateUnitSort, setPositionAddDateUnitSort ] = useState();
    const [positionAddDateUnitSpcSort, setPositionAddDateUnitSpcSort ] = useState();
    const [items, setItems] = useState(['ลำดับชั้นยศ', 'อายุ', 'ระยะเวลาการครองยศ', 'วันที่บรรจุ', 'คุณวุฒิที่ใช้บรรจุ', 'คุณวุฒิสูงสุด', 'นขต.ทอ.', 'สายวิทยาการ', 'สิทธิ์เข้าอัตรา(หน่วย)', 'สิทธิ์เข้าอัตรา(สาย)']);
    const project = {};

    const options = [
      { value: -1, label: 'มากไปน้อย' },
      { value: 1, label: 'น้อยไปมาก' },
    ]

    const seniorOptions = [
      { value: -1, label: 'ลำดับท้ายไปต้น' },
      { value: 1, label: 'ลำดับต้นไปท้าย' },
    ]

    const totSeqOption = [
      { value: 1, label: 'มากไปน้อย' },
      { value: -1, label: 'น้อยไปมาก' },
    ]

    const positionAddOption = [
      { value: 1, label: 'ก่อนไปหลัง' },
      { value: -1, label: 'หลังไปก่อน' },
    ]

    useEffect(() => {
      const getUserCourseProfile = async () => {
        const userCourseService = new UserCourseService();
        const res = await userCourseService.getUserCourseProfileByCourseName(course_name, token);
        if (res?.sort) {
            if (res.sort.rankShot != undefined) setRankShotSort(res.sort.rankShot);
            if(res.sort.age != undefined) setAgeSort(res.sort.age);
            if(res.sort.startDate != undefined) setStartDate(res.sort.startDate);
            if(res.sort.bornEduCode != undefined) setBornEduNameSort(res.sort.bornEduCode);
            if(res.sort.highDegreeCode != undefined) setDegreeAbbrNameSort(res.sort.highDegreeCode);
            if(res.sort.unit_no != undefined) setUnitSort(res.sort.unit_no);
            if(res.sort.spcNo != undefined) setSpcSort(res.sort.spcNo);
            if(res.sort.rank_year != undefined) setSeniorOfRankSort(res.sort.rank_year);
            if(res.sort.positionAddDateUnit != undefined) setPositionAddDateUnitSort(res.sort.positionAddDateUnit);
            if(res.sort.positionAddDateUnitSpc != undefined) setPositionAddDateUnitSpcSort(res.sort.positionAddDateUnitSpc);
        }
      }
      getUserCourseProfile();
      if (isUserUnitAdmin) {
        setItems(['ลำดับชั้นยศ', 'อายุ', 'ระยะเวลาการครองยศ', 'วันที่บรรจุ', 'คุณวุฒิที่ใช้บรรจุ', 'คุณวุฒิสูงสุด', 'นขต.ทอ.', 'สายวิทยาการ', 'สิทธิ์เข้าอัตรา(หน่วย)']);
      }
    }, []);  

    const handleClose = () => {
      setShowStudentCourseSortModal(false);
    }

    const handleOnStudentCourseSave = async e => {
      e.preventDefault();
      console.log('items', items)
      items.forEach(element => {
        console.log('element', element)
        switch (element) {
          case 'ลำดับชั้นยศ':
            if (rankShotSort) project.rankShot = rankShotSort;
            console.log('ลำดับชั้นยศ', project)
            break;
          case 'อายุ':
            if (ageSort) project.age = ageSort;
            console.log('อายุ', project)
            break;
          case 'คุณวุฒิที่ใช้บรรจุ':
            if (bornEduNameSort) project.bornEduCode = bornEduNameSort;
            break;
          case 'คุณวุฒิสูงสุด':
            if (degreeAbbrNameSort) project.highDegreeCode = degreeAbbrNameSort;
            break;
          case 'นขต.ทอ.': // TODO CHECK
            if (unitSort) project.unit_no = unitSort;
            break;
          case 'สายวิทยาการ': // TODO CHECK
            if (spcSort) project.spcNo = spcSort;
            break;
          case 'วันที่บรรจุ': // TODO CHECK
            if (startDateSort) project.startDate = startDateSort;
            break;
          case 'ระยะเวลาการครองยศ':
            if (seniorOfRankSort) {
              project.rank_year = seniorOfRankSort;
              project.rank_month = seniorOfRankSort;
            }
            break;
          case 'สิทธิ์เข้าอัตรา(หน่วย)':
            if (positionAddDateUnitSort) project.positionAddDateUnit = positionAddDateUnitSort;
            break;
          case 'สิทธิ์เข้าอัตรา(สาย)':
            if (positionAddDateUnitSpcSort) project.positionAddDateUnitSpc = positionAddDateUnitSpcSort;
            break;
        }
      });
      if (project) {
        console.log('project', project)
        getStudentCourse(btoa(JSON.stringify(project)));
      } else {
        getStudentCourse();
      }
      successNotify('จัดเรียงลำดับผู้สมัครสำเร็จ');
      setShowStudentCourseSortModal(false);
    }

    return (
      <>
        <Modal
            show={showStudentCourseSortModal}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            centered
          >
            <Form onSubmit={handleOnStudentCourseSave}>
              <Modal.Header closeButton>
                <Modal.Title>จัดเรียงลำดับผู้สมัคร</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <List
                  values={items}
                  onChange={({ oldIndex, newIndex }) =>
                    setItems(arrayMove(items, oldIndex, newIndex))
                  }
                  renderList={({ children, props }) => <ul {...props}>{children}</ul>}
                  renderItem={({ value, props }) => <li {...props}>{value}</li>}
                />
                <Form.Group className="mb-3">
                  <Form.Label>ลำดับชั้นยศ: </Form.Label>
                  <Select 
                    options={totSeqOption} 
                    placeholder={totSeqOption.map((option) => { if(option.value == rankShotSort) return option.label})}
                    onChange={e => setRankShotSort(e.value)} />
                </Form.Group> 
                <Form.Group className="mb-3">
                  <Form.Label>อายุ: </Form.Label>
                  <Select 
                    options={options} 
                    placeholder={options.map((option) => { if(option.value == ageSort) return option.label}) }
                    onChange={e => setAgeSort(e.value)} />
                </Form.Group> 
                <Form.Group className="mb-3">
                  <Form.Label>ระยะเวลาการครองยศ: </Form.Label>
                  <Select 
                    options={options}
                    placeholder={options.map((option) => { if(option.value == seniorOfRankSort) return option.label}) }
                    onChange={e => setSeniorOfRankSort(e.value)} />
                </Form.Group> 
                <Form.Group className="mb-3">
                  <Form.Label>วันที่บรรจุ: </Form.Label>
                    <Select 
                      options={positionAddOption}
                      placeholder={positionAddOption.map((option) => { if(option.value == startDateSort) return option.label}) }
                      onChange={e => setStartDate(e.value)} />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>คุณวุฒิที่ใช้บรรจุ: </Form.Label>
                  <Select 
                    options={options} 
                    placeholder={options.map((option) => { if(option.value == bornEduNameSort) return option.label}) }
                    onChange={e => setBornEduNameSort(e.value)} />
                </Form.Group> 
                <Form.Group className="mb-3">
                  <Form.Label>คุณวุฒิสูงสุด: </Form.Label>
                  <Select 
                    options={totSeqOption} 
                    placeholder={totSeqOption.map((option) => { if(option.value == degreeAbbrNameSort) return option.label}) }
                    onChange={e => setDegreeAbbrNameSort(e.value)} />
                </Form.Group> 
                <Form.Group className="mb-3">
                  <Form.Label>นขต.ทอ.: </Form.Label>
                  <Select 
                    options={options} 
                    placeholder={options.map((option) => { if(option.value == unitSort) return option.label}) }
                    onChange={e => setUnitSort(e.value)} />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>สายวิทยาการ: </Form.Label>
                  <Select 
                    options={options} 
                    placeholder={options.map((option) => { if(option.value == spcSort) return option.label}) }
                    onChange={e => setSpcSort(e.value)} />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>สิทธิ์เข้าอัตรา(หน่วย): </Form.Label>
                  <Select 
                    options={positionAddOption} 
                    placeholder={positionAddOption.map((option) => { if(option.value == positionAddDateUnitSort) return option.label}) }
                    onChange={e => setPositionAddDateUnitSort(e.value)} />
                </Form.Group>
                {!isUserUnitAdmin && <Form.Group className="mb-3">
                  <Form.Label>สิทธิ์เข้าอัตรา(สาย): </Form.Label>
                  <Select 
                    options={positionAddOption} 
                    placeholder={positionAddOption.map((option) => { if(option.value == positionAddDateUnitSpcSort) return option.label}) }
                    onChange={e => setPositionAddDateUnitSpcSort(e.value)} />
                </Form.Group>}
              </Modal.Body>

              <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                  ปิด
                </Button>
                <Button variant="primary" type='submit'>จัดเรียง</Button>
              </Modal.Footer>
            </Form>
        </Modal>
      </>
    );
}